import { render, staticRenderFns } from "./UserSchoolSessionResume.vue?vue&type=template&id=8a7f5450&"
import script from "./UserSchoolSessionResume.vue?vue&type=script&lang=js&"
export * from "./UserSchoolSessionResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports